var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticlesAndGuides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Articles_and_guides",
    "data-name": "Articles and guides",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#c8f8f4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_articles_1748036_000000",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M3.709,38.168H37.584a.583.583,0,0,0,.584-.584V3.709a.583.583,0,0,0-.584-.584H3.709a.584.584,0,0,0-.584.584V37.584a.583.583,0,0,0,.584.584ZM34.664,4.293H37V37H34.664Zm-3.5,0H33.5V37H31.16Zm-3.5,0h2.336V37H27.655Zm-23.362,0H26.487V37H4.293Z",
    transform: "translate(-3.125 -3.125)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M9.375,21.875H29.233v1.168H9.375Z",
    transform: "translate(-7.039 -14.866)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M9.375,28.125H29.233v1.168H9.375Z",
    transform: "translate(-7.039 -18.78)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M9.375,34.375H29.233v1.168H9.375Z",
    transform: "translate(-7.039 -22.694)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M9.375,40.625H29.233v1.168H9.375Z",
    transform: "translate(-7.039 -26.608)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M9.375,46.875H29.233v1.168H9.375Z",
    transform: "translate(-7.039 -30.521)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M39.062,53.125h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -34.435)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M39.062,59.375h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -38.349)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M39.062,65.625h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -42.263)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M39.062,71.875h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -46.176)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M39.062,78.125h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -50.09)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M39.062,84.375h8.761v1.168H39.062Z",
    transform: "translate(-25.629 -54.004)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M19.3,60.718V53.71a.583.583,0,0,0-.584-.584H9.959a.584.584,0,0,0-.584.584v7.009a.583.583,0,0,0,.584.584H18.72a.583.583,0,0,0,.584-.584Zm-1.168-.584H10.543V54.294h7.593Z",
    transform: "translate(-7.039 -34.435)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M12.5,78.125h7.593v1.168H12.5Z",
    transform: "translate(-8.996 -50.09)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M12.5,84.375h7.593v1.168H12.5Z",
    transform: "translate(-8.996 -54.004)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M20.312,12.5H31.993v1.168H20.312Z",
    transform: "translate(-13.888 -8.996)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesAndGuides);
export default __webpack_public_path__ + "static/media/articlesAndGuides.b89118d756a8a87e86bd621750928b63.svg";
export { ForwardRef as ReactComponent };